<template>
    <a-card>
        <a-page-header
            :title='"广告主监测管理"'
        />
        <a-form-model
            ref="form"
            :model="form"
            v-bind='layout'
        >
            <a-row>
                <a-col :span="7">
                    <a-form-model-item label="广告主">
                        <a-input
                            v-model="form.advertiserName"
                            placeholder="请输入"
                        />
                    </a-form-model-item>
                </a-col>
                <a-col :span="1"></a-col>
                <a-col :span="7">
                    <a-form-model-item label="广告平台">
                        <a-select
                            mode="multiple"
                            v-model="adPlatformIdList"
                            placeholder="请选择"
                            style="width: 100%;"
                            allow-clear
                            show-search
                            option-filter-prop="children"
                        >
                            <a-select-option v-for="item in platformList" :key="item.id">{{ item.adPlatformName }}</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="1"></a-col>
                <a-col :span="8">
                    <a-form-model-item label="监测链接">
                        <a-select
                            v-model="form.monitorUrlStatus"
                            placeholder="请选择"
                            style="width: 100%;"
                        >
                            <a-select-option key="1">未设置</a-select-option>
                            <a-select-option key="2">已设置</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="7">
                    <a-form-model-item label="广告主状态">
                        <a-select
                            v-model="form.status"
                            placeholder="请选择"
                            style="width: 100%;"
                        >
                            <a-select-option key="1">开启</a-select-option>
                            <a-select-option key="2">关闭</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col class="flex-end">
                    <a-space>
                        <a-button @click="handleReset">重置</a-button>
                        <a-button type="primary" @click="handleSearch">查询</a-button>
                    </a-space>
                </a-col>
            </a-row>
        </a-form-model>

        <a-table
            :loading="loading"
            :columns="columns"
            :data-source="dataList"
            :row-key="(record, index) => index"
            :pagination='false'
        >
            <div slot="action" slot-scope="text, record">
                <a @click="jumpDetailPage(record)">{{ record.monitorUrlStatus == 2 ? '已设置' : '未设置' }}</a>
            </div>
        </a-table>

        <base-pagination
            :currentPage="pagination.current"
            :pageSize="pagination.pageSize"
            :total="pagination.total"
            @onChange="handlePaginationChange"
            @onShowSizeChange="handlePaginationChange"
        />
    </a-card>
</template>

<script>
export default {
    data() {
        return {
            layout: {
                labelCol: { span: 6 },
                wrapperCol: { span: 18 }
            },
            form: {
                status: '1'
            },
            loading: false,
            columns: [
                {
                    align: 'center',
                    title: '广告主编码',
                    dataIndex: 'advertiserCode',
                    customRender(text) {
                        return text || '-'
                    }
                },
                {
                    align: 'center',
                    title: '广告主',
                    dataIndex: 'advertiserName',
                    customRender(text) {
                        return text || '-'
                    }
                },
                {
                    align: 'center',
                    title: '广告平台',
                    dataIndex: 'adPlatformName',
                    customRender(text) {
                        return text || '-'
                    }
                },
                {
                    align: 'center',
                    title: '操作',
                    scopedSlots: { customRender: 'action' }
                }
            ],
            dataList: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            adPlatformIdList: [],
            platformList: [],
        }
    },
    created() {
        this.getDataList()
        this.getAdPlatformList()
    },
    methods: {
        getAdPlatformList() {
            this.$api.core.pphtManage.getAdPlatformList().then(res => {
                if(res.code == 200) {
                    this.platformList = res.data
                } else {
                    console.error(`获取平台列表失败，${res.message}`)
                }
            })
        },
        handleSearch() {
            this.pagination.current = 1
            this.getDataList()
        },
        handleReset() {
            this.form = {
                status: '1'
            }
            this.adPlatformIdList = []
            this.pagination.current = 1
            this.pagination.pageSize = 10
            this.getDataList()
        },
        handlePaginationChange(current, pageSize) {
            this.pagination.current = current
            this.pagination.pageSize = pageSize
            this.getDataList()
        },
        getDataList() {
            this.loading = true
            let params = Object.assign(this.form, {
                adPlatformIds: this.adPlatformIdList.length > 0 ? this.adPlatformIdList.toString() : undefined,
                page: this.pagination.current,
                size: this.pagination.pageSize
            })
            this.$api.core.pphtManage.getAdvertiserMonitorList(params).then((res) => {
                this.loading = false
                if(res.code == 200) {
                    this.dataList = res.data.list || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.dataList = []
                    this.pagination.total = 0
                    console.error(`获取列表失败${res}`)
                }
            })
        },
        jumpDetailPage(record) {
            this.$router.push({
                path: `/pphtManage/monitorDetail`,
                query: {
                    advertiserId: record.advertiserId,
                    adPlatformId: record.adPlatformId
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .ant-page-header {
    padding-left: 0;
    padding-right: 0;
}
.flex-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 40px;
}
</style>